module.exports = __webpack_public_path__ + "static/media/07_hero_desktop.79e6398e.jpg";